/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InsuranceWorkspaceCreateSchema } from '../models/InsuranceWorkspaceCreateSchema';
import type { InsuranceWorkspaceDetailSchema } from '../models/InsuranceWorkspaceDetailSchema';
import type { InsuranceWorkspaceUpdateSchema } from '../models/InsuranceWorkspaceUpdateSchema';
import type { PagedInsuranceWorkspaceListSchema } from '../models/PagedInsuranceWorkspaceListSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InsuranceWorkspacesApi {
    /**
     * Get Insurance Workspace List
     * Get insurance workspace list for company. <br>Required permission: get_insurance_workspace_list
     * @returns PagedInsuranceWorkspaceListSchema OK
     * @throws ApiError
     */
    public static insuranceGetInsuranceWorkspaceListGet({
        searching = '',
        limit = 100,
        offset,
    }: {
        searching?: string,
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedInsuranceWorkspaceListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/insurance-workspaces/',
            query: {
                'searching': searching,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Create Insurance Workspace
     * Create insurance workspace. <br>Required Permission: create_insurance_workspace
     * @returns InsuranceWorkspaceDetailSchema Created
     * @throws ApiError
     */
    public static insuranceCreateInsuranceWorkspacePost({
        requestBody,
    }: {
        requestBody: InsuranceWorkspaceCreateSchema,
    }): CancelablePromise<InsuranceWorkspaceDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/insurance-workspaces/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Insurance Workspace Detail
     * Get insurance workspace detail for company. <br>Required permission: get_insurance_workspace_detail
     * @returns InsuranceWorkspaceDetailSchema OK
     * @throws ApiError
     */
    public static insuranceGetInsuranceWorkspaceDetailGet({
        insuranceWorkspaceId,
    }: {
        insuranceWorkspaceId: string,
    }): CancelablePromise<InsuranceWorkspaceDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/insurance-workspaces/{insurance_workspace_id}/',
            path: {
                'insurance_workspace_id': insuranceWorkspaceId,
            },
        });
    }
    /**
     * Update Insurance Workspace
     * Update insurance workspace. <br>Required Permission: update_insurance_workspace
     * @returns InsuranceWorkspaceDetailSchema OK
     * @throws ApiError
     */
    public static insuranceUpdateInsuranceWorkspacePut({
        insuranceWorkspaceId,
        requestBody,
    }: {
        insuranceWorkspaceId: string,
        requestBody: InsuranceWorkspaceUpdateSchema,
    }): CancelablePromise<InsuranceWorkspaceDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/insurance-workspaces/{insurance_workspace_id}/',
            path: {
                'insurance_workspace_id': insuranceWorkspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
